export default "__VITE_ASSET__DYLif_LX__"